<template>
  <DBox
    :id="'cmp-booking-promoters-promoter-contact'"
    :addButton="false"
    :addLink="false"
  >
    <div v-if="contact.company_name">
      <v-layout>
        <v-flex sm11>
          <TextField2
            :id="'company_name'"
            :placeholder="$t('company_name')"
            :label="$t('company_name')"
            :value="contact.company_name"
            :disabled="false"
            @blur="e => onTextFieldValueChange(e)"
          />
        </v-flex>
        <v-flex sm1>
          <v-btn
            style="margin: 5px 0px 0px 5px"
            flat
            icon
            color="gray"
            small
            @click="fullContactModalOpen = true"
          >
            <v-icon>fullscreen</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <TextField2
        :id="'company_legalname'"
        :placeholder="$t('legal_name')"
        :label="$t('legal_name')"
        :value="contact.company_legalname"
        :disabled="false"
        @blur="e => onTextFieldValueChange(e)"
      />
    </div>
    <div v-else>
      <v-layout>
        <v-flex sm11>
          <TextField2
            :id="'first_name'"
            :placeholder="$t('first_name')"
            :label="$t('first_name')"
            :value="contact.first_name"
            :disabled="false"
            @blur="e => onTextFieldValueChange(e)"
          />
        </v-flex>
        <v-flex sm1>
          <v-btn
            style="margin: 5px 0px 0px 5px"
            flat
            icon
            color="gray"
            small
            @click="fullContactModalOpen = true"
          >
            <v-icon>fullscreen</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <TextField2
        :id="'last_name'"
        :placeholder="$t('last_name')"
        :label="$t('last_name')"
        :value="contact.last_name"
        :disabled="false"
        @blur="e => onTextFieldValueChange(e)"
      />
    </div>

    <v-layout>
      <v-flex sm11>
        <TextField2
          :id="'address1'"
          :placeholder="$t('address')"
          :label="$t('address')"
          :value="contact.address1"
          :disabled="false"
          @blur="e => onTextFieldValueChange(e)"
        />
      </v-flex>
      <v-flex sm1>
        <v-btn
          style="margin: 5px 0px 0px 5px"
          flat
          icon
          color="gray"
          small
          @click="openMap()"
        >
          <v-icon>map</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <TextField2
      :id="'address2'"
      :placeholder="$t('address')"
      :label="$t('address')"
      :value="contact.address2"
      :disabled="false"
      @blur="e => onTextFieldValueChange(e)"
    />
    <v-layout row wrap>
      <v-flex md6>
        <TextField2
          :id="'city'"
          :placeholder="$t('city')"
          :label="$t('city')"
          :value="contact.city"
          :disabled="false"
          @blur="e => onTextFieldValueChange(e)"
        />
      </v-flex>
      <v-flex md6>
        <TextField2
          :id="'postalcode'"
          :placeholder="$t('postal_code')"
          :label="$t('postal_code')"
          :value="contact.postalcode"
          :disabled="false"
          @blur="e => onTextFieldValueChange(e)"
        />
      </v-flex>
    </v-layout>
    <!-- {{countriesTV}} -->
    <Dropdown2
      :label="$t('country')"
      :placeholder="$t('country')"
      :options="countriesTV"
      :selected="countriesTV.find(c => c.value == contact.country)"
      v-on:selectedChange="e => onDropdownChange('country', e.value)"
    />
    <Dropdown2
      :label="$t('language')"
      :placeholder="$t('language')"
      :options="languages"
      :selected="languages.find(c => c.value == contact.language)"
      v-on:selectedChange="e => onDropdownChange('language', e.value)"
    />

    <TextField2
      :id="'tax_no'"
      :placeholder="$t('tax_no')"
      :label="$t('tax_no')"
      :value="contact.tax_no"
      :disabled="false"
      @blur="e => onTextFieldValueChange(e)"
    />

    <div style="display: flex;">
      <TextField2
        :id="'vat_no'"
        :placeholder="$t('vat_id')"
        :label="$t('vat_id')"
        :value="contact.vat_no"
        :disabled="false"
        @blur="e => onTextFieldValueChange(e)"
        :bb="'0px'"
        :style="{
          '--fc2-tf-margin-focus': '-1px 3px -1px 0px',
          flex: 3
        }"
      />

      <div class="fcc">
        <div class="loading-icon" v-if="contact.vatIdValidityLoading">
          <img src="static/icons/loading.gif" alt />
        </div>
        <div
          v-if="!contact.vatIdValidityLoading"
          :class="
            `status-button ${
              contact.vat_no && promoterOverview.check_vat_id ? 'valid' : 'invalid'
            }`
          "
          @click="onVatValButtonClick(contact.vat_no)"
        >
          {{ contact.vat_no && promoterOverview.check_vat_id ? $t('valid') : $t('invalid') }}
        </div>
      </div>
    </div>

    <v-dialog v-model="fullContactModalOpen" width="800">
      <v-card class="dt-modal">
        <div class="dt-modal--body">
          <v-card>
            <v-layout row wrap>
              <v-flex md12 class="box-container">
                <div class="box-widget selected">
                  <div class="box-header gray">
                    <div class="box-header--name">{{ $t("promoter") }}</div>
                  </div>
                  <div
                    class="box-body"
                    style="overflow-y: auto; white-space: pre; padding: 5px"
                  >
                    {{ fullContactText }}
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </div>
        <div class="dt-modal--options">
          <v-layout row wrap>
            <v-flex md6 class="text-xs-left"></v-flex>

            <v-flex md6 class="text-xs-right">
              <button
                class="dt-button v1"
                @click.stop="fullContactModalOpen = false"
              >
                {{ $t("cancel") }}
              </button>
            </v-flex>
          </v-layout>
        </div>
      </v-card>
    </v-dialog>
  </DBox>
</template>

<script>
import { createCountriesTV } from "../../../../../models/country.model";
import { checkVATNumber } from "../../../../contacts/models/vat.model";

export default {
  props: ["promoterOverview"],
  data: function() {
    return {
      fullContactModalOpen: false,
    };
  },
  mounted: function() {},
  watch: {},
  computed: {
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    },
    countriesTV: function() {
      return createCountriesTV(this.promoterOverview.countries);
    },
    languages: function() {
      return (this.promoterOverview.languages || []).map(e => ({
        text: e[1],
        value: e[0]
      }));
    },
    contact: function() {
      return this.promoterOverview.contact || {};
    },
    promoter: function() {
      return this.promoterOverview.promoter || {};
    },
    fullContactText: function() {
      let full_contact = "";
      let c = this.contact;
      if(!c) return full_contact;

      if (c.company_name) {
        if (c.company_name) {
          full_contact += c.company_name;
        }
        if (c.company_legalname) {
          full_contact += " " + c.company_legalname;
        }
      } else {
        if (c.first_name) {
          full_contact += c.first_name;
        }
        if (c.last_name) {
          full_contact += " " + c.last_name;
        }
      }

      full_contact += "\n";
      if (c.address1) {
        full_contact += "" + c.address1 + "\n";
      }
      if (c.address2) {
        full_contact += "" + c.address2 + "\n";
      }
      if (c.postalcode) {
        full_contact += "" + c.postalcode + " ";
      }
      if (c.city) {
        full_contact += "" + c.city;
      }
      if (c.country) {
        full_contact += "\n" + c.country;
      }
      if (c.vat_no) {
        full_contact += "\n\n " + this.$t("vat_id") + " " + c.vat_no;
      }
      full_contact += "\n";
      if (c.phone1) {
        full_contact += "\n " + this.$t("phone_1") + " " + c.phone1;
      }
      if (c.phone2) {
        full_contact += "\n " + this.$t("phone_2") + " " + c.phone2;
      }
      if (c.email1) {
        full_contact += "\n " + this.$t("email_1") + " " + c.email1;
      }
      if (c.fax1) {
        full_contact += "\n " + this.$t("fax") + " " + c.fax1;
      }
      return full_contact;
    }
  },
  methods: {
    onVatValButtonClick(vatNumber) {
      // let country_code = vatNumber.slice(0, 2);
      // let number = vatNumber.slice(2);
      // let vat_url = `http://ec.europa.eu/taxation_customs/vies/vatResponse.html?&action=check&memberStateCode=${country_code}&number=${number}`;
      // window.open(vat_url);
      checkVATNumber(vatNumber);
    },
    onTextFieldValueChange: async function(event) {
      const { name, value } = event;
      this.$emit('changed', {name, value, contactID: this.contact["contact_id"]});
    },
    onDropdownChange: function(name, value) {
      this.onTextFieldValueChange({ name, value });
    },
    openMap() {
      window.open(
        `http://maps.google.com/maps?f=q&source=s_q&hl=en&geocode=&q=${
          this.promoter.address1
        },${this.promoter.city},${this.promoter.country}&ie=UTF8`
      );
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
